/**
 * POS-I218: the seller NTN / CNIC is stored as digits and formatted on output (SR-3).
 * 13 digits (CNIC) print as 12345-1234567-1; 7 digits (NTN) print as stored; anything else is returned
 * as the digits that were stored. Empty input gives null so callers print no NTN line.
 */
export function formatSellerNtn(stored: string | null | undefined): string | null {
  const digits = (stored ?? '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length === 13) return `${digits.slice(0, 5)}-${digits.slice(5, 12)}-${digits.slice(12)}`;
  return digits;
}
